import React, { useEffect, useState } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { match } from "react-router"
import Toggle from "react-toggle"
import SideBar from "../../common/layout/sidebar.component"
import { isError } from "../../state/helpers/Error"
import { Intl } from "../../state/helpers/IntlProps"
import NotificationSettings from "../../state/user/NotificationSettings"
import Preference from "../../state/user/Preference"
import PreferenceService from "../../state/user/PreferenceService"
import UserEditTabs from "../useredit.component"

const messages = defineMessages({
    "preApprovedQuote": {
        id: "user.edit.notification-settings.quote-prearrpoved",
        defaultMessage: "Quote Pre-Approved"
    },
    "quoteCreatedPriceList": {
        id: "user.edit.notification-settings.quote-created-pricelist",
        defaultMessage: "Quote Created From Price List"
    },
    "invoiceCreatedPriceList": {
        id: "user.edit.notification-settings.invoice-created-pricelist",
        defaultMessage: "Invoice Created From Price List"
    },
    "preDeclinedQuote": {
        id: "user.edit.notification-settings.quote-predeclined",
        defaultMessage: "Quote Pre-Declined"
    },
    "sentPayment": {
        id: "user.edit.notification-settings.send-payment",
        defaultMessage: "Send Payment"
    },
    "newConversation": {
        id: "user.edit.notification-settings.new-conversation-messgae",
        defaultMessage: "New Conversation"
    },
    "monthlyQuotes": {
        id: "user.edit.notification-settings.quote-monthly-report",
        defaultMessage: "Monthly Quotes Report"
    },
    "openedQuote": {
        id: "user.edit.notification-settings.opened_quote",
        defaultMessage: "Opened Quote"
    },
    "newSms": {
        id: "user.edit.notification-settings.new-sms-message",
        defaultMessage: "New SMS Message"
    },
    "submitConfirmed": {
        id: "user.edit.notification-settings.submit-confirmed",
        defaultMessage: "Success"
    },
    "signedDocument":{
        id: "user.edit.notification-settings.document_signed",
        defaultMessage: "Document Signed"
    },
    "orderAssigned":{
        id: "user.edit.notification-settings.order_assigned",
        defaultMessage: "Order Assigned"
    },
    "orderLineAssigned":{
        id: "user.edit.notification-settings.order_line_assigned",
        defaultMessage: "Order Line Assigned"
    }
})

interface Identifiable { userId: string }

type Props = {
    match: match<Identifiable>
    intl: Intl
}

const NotificationSettingsComponent = (props: Props) => {

    const [notificationSettings, setNotificationSettings] = useState({} as NotificationSettings)
    const [isLoading, setIsLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState("")
    const [buttonState, setButtonState] = useState("")
    const userId = props.match.params.userId

    useEffect(() => {
        SideBar.activateMenu("account")
        retrieveNotifications()
    }, [])

    const updateNotifications = async () => {
        const payload = notificationSettings
        PreferenceService.UpdateNotificationPreference(payload, userId).then(res => {
            if (isError(res)) {
                retrieveNotifications()
                setErrorMessage(res.message)
            } else {
                setButtonState(props.intl.formatMessage(messages["submitConfirmed"]))
            }
        })
    }

    const retrieveNotifications = () => {
        PreferenceService.get(userId).then(res => {
            if (!isError(res)) {
                const preference = res as Preference
                setNotificationSettings(preference.getNotificationSettings())
                setIsLoading(false)
            } else {
                setErrorMessage(res.message)
            }
        })
    }
    const formatNotificationRow = (notificationSettingsKey: string) => {
        return (
            <div className="form-group row align-items-center">
                <label className="col-2 col-form-label text-align-right" htmlFor="name">
                    <FormattedMessage {...messages[notificationSettingsKey]} />
                </label>
                <Toggle
                    checked={notificationSettings[notificationSettingsKey]}
                    onChange={() => {
                        setButtonState(""),
                        setNotificationSettings({
                            ...notificationSettings,
                            [notificationSettingsKey]: !notificationSettings[notificationSettingsKey]
                        })
                    }}
                />
            </div>
        )
    }

    return (
        <><UserEditTabs userId={userId} />
            {!isLoading &&
                <><div className="row ui-has-modules">
                    <div className="col-8">
                        <h2 className="m-0 custom-lead">
                            <FormattedMessage
                                id='settings.user.notification-settings'
                                defaultMessage='Email Notifications'
                            />
                        </h2>
                    </div>
                </div>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        {Object.keys(notificationSettings).map(x => formatNotificationRow(x))}
                    </div>
                </div>
                <div className="col-12 ui-module">
                    <div className="row">
                        <div className="col-6 text-align-left" style={{ color: "blue", padding: "8px", paddingLeft: "20px" }} >
                            {errorMessage}
                            {buttonState}
                        </div>
                        <div className="col-6 text-align-right">
                            <input
                                type="submit"
                                className="btn btn-primary"
                                onClick={() => { updateNotifications() }} />
                        </div>
                    </div>
                </div>
                </>
            }
        </>

    )
}

export default injectIntl(NotificationSettingsComponent)




// WEBPACK FOOTER //
// ./src/user/notificationSettings/NotificationSettingsComponent.tsx